import { jsx as _jsx } from "react/jsx-runtime";
import { AppLocationContext } from '@react-admin/ra-navigation';
/**
 * A wrapper for your <Layout> component which provides pre-configured context for the enterprise modules.
 *
 * What is pre-configured?
 * - An AppLocationContext, to allow the use of @react-admin/ra-navigation features.
 *
 * @param {React.ReactNode} children The content of the layout.
 *
 * @example use <SolarLayout> components with the pre-configured <LayoutWrapper> component
 *
 * import { Breadcrumb, SolarAppBar } from '@react-admin/ra-navigation';
 * import { Admin, LayoutWrapper } from '@react-admin/ra-enterprise';
 *
 * const Layout = ({ children }) => (
 *     <LayoutWrapper>
 *         <SolarLayout>
 *             <>
 *                 <Breadcrumb />
 *                 {children}
 *             </>
 *         </SolarLayout>
 *     </LayoutWrapper>
 * );
 *
 * export const App = () => (
 *     <Admin layout={Layout}>
 *           // Put your resources here
 *     </Admin >
 * );
 *
 * @example Use the <IconMenuResources>, the react-admin <AppBar> component with the pre-configured <LayoutWrapper> component
 *
 * import { Admin, LayoutWrapper } from '@react-admin/ra-enterprise';
 * import { IconMenuResources } from '@react-admin/ra-navigation';
 * import { AppBar, Layout } from 'react-admin';
 *
 * const CustomLayout = ({ children }) => (
 *     <LayoutWrapper>
 *         <Layout menu={IconMenuResources} appBar={AppBar}>
 *             {children}
 *         </Layout>
 *     </LayoutWrapper>
 * );
 *
 * export const App = () => (
 *     <Admin layout={CustomLayout}>// Put your resources here</Admin>
 * );
 *
 */
export var LayoutWrapper = function (_a) {
    var children = _a.children;
    return _jsx(AppLocationContext, { children: children });
};
